import React from 'react';

import JackpotGroupDetailItem from "./jackpot-group-detail-item";
import {Link} from "react-router-dom";


export const JackpotGroupCard = ({group}) => (group ?
        <div className="jackpot-group__card"
             style={{
                 backgroundImage: group.hasBackground ? `url(${group.background})`: '',
            }}
        >
            <Link to={`/slots/jackpots/${group.id}`}
                  className="jackpot-group__card-logo"
            >
                {group.bigImgLink ?
                    <img
                        className="jackpot-group__card-logo-image"
                        src={group.bigImgLink}
                        alt="slots-game"
                    />
                    :
                    <div className=" game__provider-without-img">
                        {group.name}
                    </div>
                }
            </Link>
            <div className="jackpot-group__info-box">
                <div className="jackpot-group__tier jackpot-group__tier--grand">
                    <JackpotGroupDetailItem jackpotId={group.id} type="grand"/>
                </div>
                <div className="jackpot-group__tier jackpot-group__tier--major">
                    <JackpotGroupDetailItem jackpotId={group.id} type="major"/>
                </div>
                <div className="jackpot-group__tier jackpot-group__tier--minor jackpot-group__small-jackpots">
                    <JackpotGroupDetailItem jackpotId={group.id} type="minor"/>
                </div>
                <div className="jackpot-group__tier jackpot-group__tier--mini jackpot-group__small-jackpots">
                    <JackpotGroupDetailItem jackpotId={group.id} type="mini"/>
                </div>
            </div>
        </div>
        : null
);